// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import MainScreen from "./components/MainScreen/MainScreen";
import LoginScreen from "./components/LoginScreen/LoginScreen";
import Companies from "./components/Companies/Index";
import Leads from "./components/LeadsFolder/Index";
import ICPDefinitionPage from "./components/LeadsFolder/ICPDefinitionPage";
import Integrations from "./components/Integrations/Index";
import SignupScreen from "./components/SignupScreen/SignupScreen";
import OnboardingMainScreen from "./components/Onboarding/OnboardingMainScreen";
import * as amplitude from '@amplitude/analytics-browser';
import PipelineMainScreen from "./components/Pipeline/PipelineMainScreen";

// Initialize Amplitude
amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY, {
    autocapture: true,
    defaultTracking: {
        sessions: true,
        pageViews: true,
        formInteractions: true,
        fileDownloads: true
    }
});

// Version increment for Greyson Vercel deployment

function App() {
    return (
        <Router>
            <AuthProvider> {/* Moved inside Router */}
                <div className="mx-auto bg-white">
                    <Routes>
                        <Route path="/" element={<Navigate to="/login" replace />} />
                        <Route path="/login" element={<LoginScreen />} />
                        <Route path="/signup" element={<SignupScreen />} />
                        <Route path="/onboarding" element={<OnboardingMainScreen />} />
                        {/* <Route
                            path="/companies/:id"
                            element={
                                <ProtectedRoute>
                                    <MainScreen />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/companies"
                            element={
                                <ProtectedRoute>
                                    <Companies />
                                </ProtectedRoute>
                            }
                        /> */}
                        <Route
                            path="/leads"
                            element={
                                <ProtectedRoute>
                                    <Leads />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/generate-leads"
                            // path="/generate-leads/:id"
                            element={
                                <ProtectedRoute>
                                    <ICPDefinitionPage />
                                </ProtectedRoute>
                            }
                        />
                        {/* <Route
                            path="/pipeline"
                            element={
                                <ProtectedRoute>
                                    <PipelineMainScreen />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/integrations"
                            element={
                                <ProtectedRoute>
                                    <Integrations />
                                </ProtectedRoute>
                            }
                        /> */}
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    </Routes>
                </div>
            </AuthProvider>
        </Router>
    );
}

export default App;